import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PAGING_HEADERS } from '@app/app.constants';
import {
  ProvisionCustomReport,
  ProvisionUploadReport,
  Report,
  ReportSagaState,
  UpdateReportModel,
} from '@app/modules/reports/types/report.types';
import { ApiHeaders } from '@core/core.types';
import { HttpUtils } from '@core/utils/http-utils';
import { environment } from '@root/environments/environment';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  private readonly apiUrl = `${environment.apiUrl}/digital-reports/reports`;

  constructor(private http: HttpClient) {}

  getReport(reportId: string): Observable<Report> {
    return this.http.get<Report>(`${this.apiUrl}/${reportId}`);
  }

  updateReport(report: UpdateReportModel) {
    return this.http.put<{ id: string }>(`${this.apiUrl}/${report.id}`, report);
  }

  provisionCustomReport(report: ProvisionCustomReport) {
    return this.http.post<{ id: string }>(`${this.apiUrl}/custom`, report);
  }

  provisionUploadReport(data: ProvisionUploadReport) {
    return this.http.post<{ id: string }>(`${this.apiUrl}/upload`, data);
  }
  massApproveReports(reportIds: string[]) {
    return this.http.post(`${this.apiUrl}/batch`, {
      reportIds,
    });
  }

  approveReport(reportId: string, payload) {
    return this.http.put(`${this.apiUrl}/${reportId}/approve`, {
      ...payload,
    });
  }

  disapproveReport(reportId: string) {
    return this.http.put(`${this.apiUrl}/${reportId}/disapprove`, {});
  }

  archiveReport(reportId: string) {
    return this.http.put(`${this.apiUrl}/${reportId}/archive`, {});
  }

  removeReport(reportId: string) {
    return this.http.delete(`${this.apiUrl}/${reportId}`);
  }

  checkApprovalState(id: string): Observable<ReportSagaState> {
    return this.http.get<ReportSagaState>(`${this.apiUrl}/batch/${id}`);
  }

  confirmMassReportApproval(id: string) {
    return this.http.post<any>(`${this.apiUrl}/batch/${id}/confirm`, {});
  }

  reportUrl(reportId: string) {
    return this.http.get<string>(`${this.apiUrl}/${reportId}/read-uri`);
  }

  listReports(filters: HttpParams, headers: ApiHeaders) {
    return this.http
      .get<Report[]>(`${this.apiUrl}`, {
        observe: 'response',
        params: filters,
        headers: HttpUtils.buildHttpHeaders(headers),
      })
      .pipe(
        map((response) => ({
          items: response.body,
          continuationToken: response.headers.get(
            PAGING_HEADERS.continuationToken
          ),
          totalCount: parseInt(
            response.headers.get(PAGING_HEADERS.totalCount),
            10
          ),
        }))
      );
  }
}
